module.exports = __webpack_public_path__ + "img/tractor_verde_fondo.785a6477.jpeg";